import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonDirectives } from '@app/shared/directives/common-directives';

@Component({
  selector: 'app-action-buttons',
  imports: [MatButtonModule, CommonDirectives],
  templateUrl: './action-buttons.component.html'
})
export class ActionButtonsComponent {
  @Input() buttonOneTitle: string = 'Cancel';
  @Input() buttonTwoTitle: string = 'Next';
  @Input() buttonOneDisabled: boolean = false;
  @Input() buttonTwoDisabled: boolean = false;
  @Input() justify: string = 'justify-between'
  @Output() onButtonOneClick = new EventEmitter();
  @Output() onButtonTwoClick = new EventEmitter();

  handleButtonOneClick() {
    this.onButtonOneClick.emit();
  }

  handleButtonTwoClick() {
    this.onButtonTwoClick.emit();
  }
}
